module.exports = __webpack_public_path__ + "img/proposal_banner.d72b2b4c.png";